<div class="content-card">
    <div class="card-inner">
        <p-fluid>
            <div class="font-semibold text-xl mb-4 module-name">
                Client List
            </div>

            <p-table #dt [value]="viewModel.clients" [rows]="10" [paginator]="true"
                [globalFilterFields]="['name','description']" [tableStyle]="{ 'min-width': '75rem' }"
                [rowHover]="true" currentPageReportField="Showing {first} to {last} of {totalRecords} clients"
                [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 20, 30]">

                <ng-template #caption>
                    <div class="flex flex-col justify-between">

                        <div class="flex flex-col items-end gap-3 flex-1 mt-4">
                            <p-button label="Add" icon="pi pi-plus" severity="info" (click)="viewModel.openNew()" />
                            <!-- Search below the Add button -->
                            <div class="search-container">
                                <p-iconfield iconPosition="left">
                                    <p-inputicon>
                                        <i class="pi pi-search"></i>
                                    </p-inputicon>
                                    <input pInputText type="text" (input)="viewModel.onGlobalFilter(dt, $event)"
                                        placeholder="Search..." />
                                </p-iconfield>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <ng-template #header>
                    <tr>
                        <th pSortableColumn="name" style="min-width:16rem">
                            Client Name
                            <p-sortIcon field="name" />
                        </th>
                        <th style="min-width:16rem">
                            Description
                        </th>
                        <th style="width: 16rem">Action</th>
                    </tr>
                </ng-template>

                <ng-template #body let-client>
                    <tr>
                        <td style="min-width: 16rem">
                            <span class="scenario-name-link cursor-pointer text-blue-600 underline hover:text-blue-800"
                                (click)="viewModel.viewClient(client)">
                                {{ client.name }}
                            </span>
                        </td>
                        <td style="min-width: 16rem">{{ client.description }}</td>
                        <td style="width: 16rem">
                            <p-button icon="pi pi-pencil" severity="info" [rounded]="true" [outlined]="true"
                                pTooltip="Edit" (click)="viewModel.editClient(client)" tooltipPosition="top"
                                class="mr-2" />
                            <p-button icon="pi pi-trash" severity="danger" [rounded]="true" [outlined]="true"
                                pTooltip="Delete" (click)="viewModel.deleteClient(client)" tooltipPosition="top" />
                        </td>
                    </tr>
                </ng-template>

                <ng-template #emptymessage>
                    <tr>
                        <td colspan="3" class="noData">No clients found.</td>
                    </tr>
                </ng-template>
            </p-table>
        </p-fluid>

        <!-- Client Dialog -->
        <p-dialog [(visible)]="viewModel.packageDialog" [appendTo]="'body'" [style]="{ width: '900px' }"
            [header]="viewModel.isViewMode ? 'Client Details' : (viewModel.isEditMode ? 'Edit Client' : 'Create Client')"
            [modal]="true" [dismissableMask]="false" [blockScroll]="true" [draggable]="false"
            styleClass="module-name package-dialog" (onHide)="viewModel.hideDialog()">

            <ng-template #content>
                <form [formGroup]="viewModel.clientForm" class="p-fluid" autocomplete="off" data-lpignore="true">
                    <div class="field">
                        <label for="clientName" class="block font-medium mb-2">Client Name <span
                                class="text-red-500">*</span></label>
                        <input id="clientName" type="text" pInputText formControlName="name"
                            placeholder="Enter client name" class="w-full" />
                        <small class="text-red-500"
                            *ngIf="viewModel.clientForm.get('name')?.invalid && viewModel.clientForm.get('name')?.touched && !viewModel.isViewMode">
                            Client Name is required.
                        </small>
                    </div>

                    <div class="field mt-4">
                        <label for="description" class="block font-medium mb-2">Description <span
                                class="text-red-500">*</span></label>
                        <textarea id="description" pTextarea formControlName="description"
                            placeholder="Enter description" class="w-full" rows="3"></textarea>
                        <small class="text-red-500"
                            *ngIf="viewModel.clientForm.get('description')?.invalid && viewModel.clientForm.get('description')?.touched && !viewModel.isViewMode">
                            Description is required.
                        </small>
                    </div>

                    <!-- Tenant Configuration Section -->
                    <div class="tenant-section mt-6" *ngIf="!viewModel.isViewMode || (viewModel.isViewMode && viewModel.tenantsArray.length > 0)">
                        <div class="flex justify-between items-center mb-4">
                            <label class="font-semibold text-lg">Tenant Configuration<span *ngIf="!viewModel.isViewMode" class="text-red-500">*</span></label>
                            <p-button *ngIf="!viewModel.isViewMode" icon="pi pi-plus" [rounded]="true" severity="success"
                                (click)="viewModel.addTenant()" pTooltip="Add Tenant" tooltipPosition="left" />
                        </div>

                        <div formArrayName="tenants">
                            <div *ngFor="let tenant of viewModel.tenantsArray.controls; let i = index"
                                [formGroupName]="i" class="tenant-config-item border rounded-xl p-4 mb-4 relative">

                                <div class="flex justify-between items-center mb-3">
                                    <div class="flex items-center gap-2">
                                        <span class="tenant-number">{{ i + 1 }}</span>
                                        <span class="font-medium text-gray-700">Tenant</span>
                                    </div>
                                    <p-button *ngIf="!viewModel.isViewMode" icon="pi pi-trash" [rounded]="true" [outlined]="true" [raised]="true" severity="danger"
                                        (click)="viewModel.removeTenant(i)"
                                        [style]="{'width': '2rem', 'height': '2rem'}" />
                                </div>

                                <!-- Row 1: Tenant Type, Name, URL -->
                                <div class="grid grid-cols-3 gap-4 mb-3">
                                    <div class="field">
                                        <label class="block font-medium mb-1">Tenant Type <span class="text-red-500">*</span></label>
                                        <p-select formControlName="tenantId" [options]="viewModel.tenantTypes"
                                            optionLabel="label" optionValue="value" placeholder="Select Type"
                                            class="w-full" styleClass="w-full" [appendTo]="'body'" />
                                        <small class="text-red-500"
                                            *ngIf="tenant.get('tenantId')?.invalid && tenant.get('tenantId')?.touched">
                                            Tenant Type is required.
                                        </small>
                                    </div>
                                    <div class="field">
                                        <label class="block font-medium mb-1">Tenant Name <span class="text-red-500">*</span></label>
                                        <input pInputText formControlName="tenantName" placeholder="Enter tenant name" class="w-full" />
                                        <small class="text-red-500"
                                            *ngIf="tenant.get('tenantName')?.invalid && tenant.get('tenantName')?.touched">
                                            Tenant Name is required.
                                        </small>
                                    </div>
                                    <div class="field">
                                        <label class="block font-medium mb-1">Tenant URL <span class="text-red-500">*</span></label>
                                        <input pInputText formControlName="tenantUrl" placeholder="Enter tenant URL" class="w-full" />
                                        <small class="text-red-500"
                                            *ngIf="tenant.get('tenantUrl')?.invalid && tenant.get('tenantUrl')?.touched">
                                            Tenant URL is required.
                                        </small>
                                    </div>
                                </div>

                                <!-- Row 2: Auth Type -->
                                <div class="grid grid-cols-3 gap-4 mb-3">
                                    <div class="field">
                                        <label class="block font-medium mb-1">Auth Type <span class="text-red-500">*</span></label>
                                        <p-select formControlName="authType" [options]="viewModel.authTypes"
                                            optionLabel="label" optionValue="value" placeholder="Select Auth Type"
                                            class="w-full" styleClass="w-full" [appendTo]="'body'" (onChange)="viewModel.onAuthTypeChange(i)" />
                                        <small class="text-red-500"
                                            *ngIf="tenant.get('authType')?.invalid && tenant.get('authType')?.touched">
                                            Auth Type is required.
                                        </small>
                                    </div>
                                </div>

                                <!-- Basic Auth Fields -->
                                <div *ngIf="viewModel.isBasicAuth(i)" class="grid grid-cols-2 gap-4 mb-3 auth-fields">
                                    <div class="field">
                                        <label class="block font-medium mb-1">Username <span class="text-red-500">*</span></label>
                                        <input pInputText formControlName="username" placeholder="Enter username" class="w-full" autocomplete="off" />
                                        <small class="text-red-500"
                                            *ngIf="tenant.get('username')?.invalid && tenant.get('username')?.touched">
                                            Username is required.
                                        </small>
                                    </div>
                                    <div class="field">
                                        <label class="block font-medium mb-1">Password <span class="text-red-500">*</span></label>
                                        <p-password formControlName="password" [placeholder]="tenant.get('id')?.value ? 'Leave blank to keep existing' : 'Enter password'" [toggleMask]="true" [feedback]="false" styleClass="w-full" autocomplete="new-password" />
                                        <small class="text-red-500"
                                            *ngIf="tenant.get('password')?.invalid && tenant.get('password')?.touched">
                                            Password is required.
                                        </small>
                                    </div>
                                </div>

                                <!-- Token Based Auth Fields -->
                                <div *ngIf="viewModel.isTokenAuth(i)" class="auth-fields">
                                    <div class="grid grid-cols-2 gap-4 mb-3">
                                        <div class="field">
                                            <label class="block font-medium mb-1">Token Endpoint <span class="text-red-500">*</span></label>
                                            <input pInputText formControlName="tokenEndpoint" placeholder="Enter token endpoint" class="w-full" />
                                            <small class="text-red-500"
                                                *ngIf="tenant.get('tokenEndpoint')?.invalid && tenant.get('tokenEndpoint')?.touched">
                                                Token Endpoint is required.
                                            </small>
                                        </div>
                                        <div class="field">
                                            <label class="block font-medium mb-1">Authorization Endpoint <span class="text-red-500">*</span></label>
                                            <input pInputText formControlName="authorizationEndpoint" placeholder="Enter authorization endpoint" class="w-full" />
                                            <small class="text-red-500"
                                                *ngIf="tenant.get('authorizationEndpoint')?.invalid && tenant.get('authorizationEndpoint')?.touched">
                                                Authorization Endpoint is required.
                                            </small>
                                        </div>
                                    </div>
                                    <div class="grid grid-cols-2 gap-4 mb-3">
                                        <div class="field">
                                            <label class="block font-medium mb-1">Client ID <span class="text-red-500">*</span></label>
                                            <input pInputText formControlName="oauthClientId" placeholder="Enter client ID" class="w-full" />
                                            <small class="text-red-500"
                                                *ngIf="tenant.get('oauthClientId')?.invalid && tenant.get('oauthClientId')?.touched">
                                                Client ID is required.
                                            </small>
                                        </div>
                                        <div class="field">
                                            <label class="block font-medium mb-1">Client Secret <span class="text-red-500">*</span></label>
                                            <p-password formControlName="oauthClientSecret" [placeholder]="tenant.get('id')?.value ? 'Leave blank to keep existing' : 'Enter client secret'" [toggleMask]="true" [feedback]="false" styleClass="w-full" autocomplete="new-password" />
                                            <small class="text-red-500"
                                                *ngIf="tenant.get('oauthClientSecret')?.invalid && tenant.get('oauthClientSecret')?.touched">
                                                Client Secret is required.
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="viewModel.tenantsArray.length === 0 && !viewModel.isViewMode" class="text-center text-gray-400 py-4 border border-dashed rounded-lg">
                            No tenants configured. Click + to add a tenant.
                        </div>
                    </div>
                </form>
            </ng-template>

            <ng-template #footer>
                <ng-container *ngIf="viewModel.isViewMode">
                    <p-button label="Close" icon="pi pi-times" severity="warn"
                        (click)="viewModel.hideDialog()"></p-button>
                </ng-container>
                <ng-container *ngIf="!viewModel.isViewMode">
                    <p-button label="Cancel" icon="pi pi-times" severity="warn"
                        (click)="viewModel.hideDialog()"></p-button>
                    <p-button [label]="viewModel.isEditMode ? 'Update' : 'Submit'"
                        [disabled]="viewModel.isSubmitDisabled()"
                        icon="pi pi-check"
                        severity="success"
                        (onClick)="viewModel.saveClient()" />
                </ng-container>
            </ng-template>
        </p-dialog>

        <p-confirmdialog [style]="{ width: '450px', maxWidth: '50vw' }" [baseZIndex]="10000" [appendTo]="'body'"
            styleClass="custom-confirm-dialog" />
    </div>
</div>
